import { render, staticRenderFns } from "./teaching.vue?vue&type=template&id=76d4061e"
import script from "./teaching.vue?vue&type=script&lang=js"
export * from "./teaching.vue?vue&type=script&lang=js"
import style0 from "./teaching.vue?vue&type=style&index=0&id=76d4061e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-45869d479f/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports